import requireLoggedInSaga from 'routes/helpers/requireLoggedIn';

export const ReferRoute = store => ({
  path: 'refer',
  onEnter: (nextState, replaceState, cb) => {
    replaceState('/search?refer=1');
    store
      .runSagaOnce(requireLoggedInSaga, nextState, replaceState)
      .toPromise()
      .then(cb, cb);
  },
});
